export const MAP_BUILDING_COLOR_MODE_STREETS = "#fde8c8";
export const MAP_BUILDING_COLOR_MODE_LIGHT = "#ddd";
